import { TenantBaseApi } from "api/TenantSlug/TenantBaseApi.ts";

import GetOutgoingPostbackLogsResponse = App.Http.Responses.OutgoingPostbackLog.GetOutgoingPostbackLogsResponse;
import GetOutgoingPostbackLogsRequest = App.Http.Requests.OutgoingPostbackLog.GetOutgoingPostbackLogsRequest;
import GetOutgoingPostbackLogResponse = App.Http.Responses.OutgoingPostbackLog.GetOutgoingPostbackLogResponse;
import BaseExportRequest = App.Http.Requests.BaseExportRequest;
import ExportResponse = App.Http.Responses.ExportResponse;

class OutgoingPostbackLogApi extends TenantBaseApi {
    async index(request: GetOutgoingPostbackLogsRequest): Promise<GetOutgoingPostbackLogsResponse> {
        return await this.get<GetOutgoingPostbackLogsResponse, GetOutgoingPostbackLogsRequest>(
            "/outgoing-postback-logs",
            { params: request }
        );
    }

    async show(
        logId: string,
        request: {
            filter?: App.Http.Requests.FilterRequest;
        }
    ): Promise<GetOutgoingPostbackLogResponse> {
        return await this.get<GetOutgoingPostbackLogResponse, typeof request>(`/outgoing-postback-logs/${logId}`, {
            params: request,
        });
    }

    async export(request?: BaseExportRequest): Promise<ExportResponse> {
        return await this.post<ExportResponse, BaseExportRequest>(`/outgoing-postback-logs/export`, request);
    }
}

export const outgoingPostbackLogApi = new OutgoingPostbackLogApi();
